import { BellAlertIcon } from '@heroicons/react/20/solid';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'components/shadcn/ui/button';

const ActiveAlerts = ({ alertMessages }) => {
    const navigate = useNavigate();
    if (!alertMessages || alertMessages.length === 0) return null;
    return (
        <div>
            {alertMessages.map((alert, index) => (
                <div
                    key={index}
                    className={`mb-2 flex items-center justify-between rounded border p-2 text-sm dark:border-none ${alert?.level === 'Fault' ? 'border-error-foreground bg-error text-error-foreground' : 'border-warning-foreground bg-warning text-warning-foreground'} `}
                >
                    <div className="flex flex-1 items-center">
                        <BellAlertIcon className="h-5 w-5" />
                        <div className="mx-2 flex flex-col lg:w-full lg:flex-row lg:items-center">
                            <strong className="lg:flex-1">
                                {alert.message}
                            </strong>
                            {alert.deviceType === 'MASTER' ? (
                                <span className="mr-2 text-xs">
                                    <strong>BMS:</strong>{' '}
                                    <span
                                        className="truncate-start lg:truncate-start-none inline-block max-w-[120px] align-bottom lg:max-w-none"
                                        title={alert.alertSerialNumber}
                                    >
                                        {alert.alertSerialNumber}
                                    </span>
                                </span>
                            ) : alert.deviceType === 'PACK' ? (
                                <>
                                    <span className="mr-2 text-xs">
                                        <strong>BMS:</strong>{' '}
                                        <span
                                            className="truncate-start lg:truncate-start-none inline-block max-w-[120px] align-bottom lg:max-w-none"
                                            title={alert.masterSerialNumber}
                                        >
                                            {alert.masterSerialNumber}
                                        </span>
                                    </span>
                                    <span className="text-xs">
                                        <strong>Module:</strong>{' '}
                                        <span
                                            className="truncate-start lg:truncate-start-none inline-block max-w-[120px] align-bottom lg:max-w-none"
                                            title={alert.alertSerialNumber}
                                        >
                                            {alert.alertSerialNumber}
                                        </span>
                                    </span>
                                </>
                            ) : null}
                        </div>
                    </div>
                    <Button
                        variant={alert?.level === 'Fault' ? 'error' : 'warning'}
                        size="sm"
                        onClick={() => {
                            if (alert.deviceType === 'EMS') {
                                navigate(`/devices/${alert.thingId}/logs`);
                            } else if (alert.deviceType === 'MASTER' || alert.isSingleStack) {
                                navigate(`/devices/${alert.thingId}/${alert.alertSerialNumber}/logs`);
                            } else {
                                navigate(`/devices/${alert.thingId}/${alert.masterSerialNumber}/${alert.alertSerialNumber}/logs`);
                            }
                        }}
                    >
                        View Logs
                    </Button>
                </div>
            ))}
        </div>
    );
};

export default ActiveAlerts;
